export default __webpack_public_path__ + "images/models/310f7c665810b77d53969c2199c9a36f.usdz";